import React, { useState } from "react";
import * as Yup from "yup";
import axios from "axios";
import { Formik } from "formik";
import HtmlParser from "html-react-parser";
import { mailDomainsBlacklist, fieldsFilter, hubspot_contactUsForm_fields} from "../utils/hubspot_utils.js";
// import { globalHistory as history } from '@reach/router';

const PORTAL_ID = "7284441";
const FORM_ID = "9306a790-41c5-406e-b321-1820dc9e49fa";

function toFormGroupClass(field, state, error) {
  if (state.touched[field] && (state.errors[field] || error)) {
    return "pt-form-group pt-intent-danger-contactus";
  } else if (
    state.touched[field] &&
    state.values &&
    state.values[field] !== ""
  ) {
    return "pt-form-group pt-intent-success";
  } else {
    return "pt-form-group";
  }
}

export const DemoFormContactus = (props) => {
  const [error, setError] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Must be a valid email")
      .matches(mailDomainsBlacklist, "Company Email Only")
      .required("Required"),
    note: Yup.string()
    .max(1000, "Max 1000 characters")
    .required("Required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    const url = typeof window !== "undefined" ? window.location.href : "";
    const pageTitle = typeof document !== "undefined" ? document.title : "";

    values.source = props.source ? props.source : HtmlParser("");

    const UTMparams = JSON.parse(sessionStorage.getItem("UTMparams"));
    const referrer = sessionStorage.getItem("Referrer");

    const fields = [
      { name: "email", value: values.email },
      { name: "notes", value: values.note },
    ];

    if (UTMparams && typeof UTMparams[0] === "string") {
      fields.push({ name: UTMparams[0], value: UTMparams[1] });
    } else if (UTMparams) {
      UTMparams.forEach((property) => {
        fields.push({ name: property[0], value: property[1] });
      });
    }

    fields.push({ name: "referrer", value: referrer || "Empty" });
    const context = {
      pageUri: url,
      pageName: pageTitle,
    };

    const filteredFieldsArray = fieldsFilter(fields, hubspot_contactUsForm_fields);

    try {
      // ============ Sending to Hubspot ============ //
      await axios.request({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        url: `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`,
        data: JSON.stringify({
          fields: filteredFieldsArray,
          context: context,
        }),
      });

      setSubmitted(true);
    } catch (error) {
      setError(true);
      return;
    }

    // ============ Sending to Charthop API (Slack) ============ //
    await axios.request({
      method: "POST",
      url: "https://api.charthop.com/contact",
      data: { ...values },
    });
  };

  if (submitted) {
    return (
      <div className="pt-callout pt-intent-primary pt-submission-success">
        <img
          src={"/home/successfulFormSubmission.svg"}
          alt="The ChartHop logo"
        />
        <p>Thanks for your interest in ChartHop!</p>
        <p>We'll be in touch soon.</p>
        {/*titleToggleJS()*/}
      </div>
    );
  }

  return (
    <div className="container">
      <div className="row align-items-top justify-content-around ">
        <div className="longFormParentContainer col-xs-12">
          <Formik
            initialValues={{ email: "", note: "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            render={(form) => (
              <form className="demolongform" onSubmit={form.handleSubmit}>
                <div className={toFormGroupClass("email", form)}>
                  <label className="pt-label" htmlFor="email">
                    {/* Company Email */}<span hidden>Company Email</span>
                  </label>
                  <input
                    placeholder="Company Email"
                    id="email"
                    className="text-email-contactus"
                    type="text"
                    value={form.values.email}
                    onChange={form.handleChange}
                  />
                  {form.touched.email && form.errors.email && (
                    <div className="pt-form-helper-text-contactus">
                      {form.errors.email}
                    </div>
                  )}
                </div>

                <div className={toFormGroupClass("note", form)}>
                  <label className="pt-label" htmlFor="note">
                    {/* Message */}<span hidden>Message</span>
                  </label>
                  <textarea
                    placeholder="Your Message"
                    id="note"
                    className="text-note-contactus"
                    value={form.values.note}
                    onChange={form.handleChange}
                  />
                  {form.touched.note && form.errors.note && (
                    <div className="pt-form-helper-text-contactus">
                      {form.errors.note}
                    </div>
                  )}
                </div>

                <div className="pt-form-button">
                  <button
                    ref={(btn) => {
                      btn = btn;
                    }}
                    type="submit"
                    className="button primary submit-button"
                  >
                    SUBMIT
                  </button>
                </div>

                {error && (
                  <div
                    className="pt-callout pt-intent-danger"
                    style={{ marginTop: 10 }}
                  >
                    Sorry, but we had an unexpected problem submitting your
                    request. Try again later, or send a note to{" "}
                    <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
                  </div>
                )}
              </form>
            )}
          />
        </div>
      </div>
    </div>
  );
};
